import React from 'react';
import { FieldTd, HeaderTh, joinNonEmpty, tableStyleBase, ValueTd } from 'components/account/jobs-v2/dropdowns/IdDocument/utils';
import { captureTypeMap } from 'models/jobs/jobs';
import { humanIdType } from 'utils/jobs';
const tableStyle = {
    borderCollapse: 'collapse',
    border: '1px solid #EFEFF1'
};
const thTitleStyle = {
    backgroundColor: '#F6F6F8',
    padding: '10px 16px',
    borderBottom: '1px solid #EFEFF1',
    borderTop: '3px solid #E4E5E7',
    textAlign: 'left',
    fontSize: '1.6rem',
    fontWeight: 700,
    color: '#1D1D1D',
    textTransform: 'uppercase'
};
export const IdvDetails = ({ ocrData, barcodeData, unverifiedIdAddress, idType, captureType, country, state, motorcycle }) => {
    return (React.createElement("div", { style: {
            backgroundColor: '#FFF'
        } },
        React.createElement("div", { style: {
                backgroundColor: '#635BFF',
                color: '#FFF',
                textAlign: 'center',
                fontSize: '16px',
                fontWeight: 700,
                padding: '12px'
            } }, "OCR & Barcode Details"),
        React.createElement("table", { style: { ...tableStyleBase, ...tableStyle } },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("th", { colSpan: 3, style: thTitleStyle }, "EXTRACTED")),
                React.createElement("tr", null,
                    React.createElement(HeaderTh, { width: "25%" }, "Field"),
                    React.createElement(HeaderTh, { width: "40%" }, "OCR"),
                    React.createElement(HeaderTh, { width: "40%" }, "Barcode")),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "First Name"),
                    React.createElement(ValueTd, null, ocrData?.firstName),
                    React.createElement(ValueTd, null, barcodeData?.firstName)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Middle Name"),
                    React.createElement(ValueTd, null, ocrData?.middleName),
                    React.createElement(ValueTd, null, barcodeData?.middleName)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Last Name"),
                    React.createElement(ValueTd, null, ocrData?.lastName),
                    React.createElement(ValueTd, null, barcodeData?.lastName)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Birth Date"),
                    React.createElement(ValueTd, null, ocrData?.birthDate),
                    React.createElement(ValueTd, null, barcodeData?.birthDate)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "ID Number"),
                    React.createElement(ValueTd, null, ocrData?.id),
                    React.createElement(ValueTd, null, barcodeData?.id)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Address"),
                    React.createElement(ValueTd, null, ocrData?.address ?? unverifiedIdAddress),
                    React.createElement(ValueTd, null, joinNonEmpty([
                        barcodeData?.streetAddress,
                        barcodeData?.streetAddress2,
                        barcodeData?.city ? `${barcodeData.city},` : barcodeData?.city,
                        barcodeData?.state,
                        barcodeData?.postalCode
                    ]))),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Country"),
                    React.createElement(ValueTd, null, country),
                    React.createElement(ValueTd, null, barcodeData?.country)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "State"),
                    React.createElement(ValueTd, null, state),
                    React.createElement(ValueTd, null, barcodeData?.state)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Expiration Date"),
                    React.createElement(ValueTd, null, ocrData?.expireDate),
                    React.createElement(ValueTd, null, barcodeData?.expireDate)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Issue Date"),
                    React.createElement(ValueTd, null, ocrData?.issueDate),
                    React.createElement(ValueTd, null, barcodeData?.issueDate)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Class"),
                    React.createElement(ValueTd, null, ocrData?.class),
                    React.createElement(ValueTd, null, barcodeData?.class)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Endorsements"),
                    React.createElement(ValueTd, null, ocrData?.endorsements),
                    React.createElement(ValueTd, null, barcodeData?.endorsements)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Motorcycle"),
                    React.createElement(ValueTd, null, motorcycle),
                    React.createElement(ValueTd, null, motorcycle)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "ID Type"),
                    React.createElement(ValueTd, null, humanIdType(idType)),
                    React.createElement(ValueTd, null)),
                React.createElement("tr", null,
                    React.createElement(FieldTd, null, "Capture Type"),
                    React.createElement(ValueTd, null, captureType ? captureTypeMap[captureType] : undefined),
                    React.createElement(ValueTd, null))))));
};
